import * as React from 'react';
import mitt from 'mitt';
const emitter = mitt();
export const usePersistedState = (initialState, storageKey) => {
    const [value, setValue] = React.useState(initialState);
    const latestValueRef = React.useRef(value);
    latestValueRef.current = value;
    React.useEffect(() => {
        const syncStorage = () => {
            const latestValue = window.localStorage.getItem(storageKey);
            if (latestValue &&
                latestValue !== JSON.stringify(latestValueRef.current)) {
                const result = parseSafely(latestValue);
                if (result !== null) {
                    setValue(result);
                }
            }
        };
        syncStorage();
        window.addEventListener('storage', syncStorage);
        const onChange = (data) => {
            if (data.key === storageKey) {
                if (data.value !== latestValueRef.current) {
                    setValue(data.value);
                }
            }
        };
        emitter.on('change', onChange);
        return () => {
            window.removeEventListener('storage', syncStorage);
            emitter.off('change', onChange);
        };
    }, [storageKey]);
    const set = React.useCallback((newValue) => {
        setValue(newValue);
        if (newValue === initialState) {
            window.localStorage.removeItem(storageKey);
        }
        else {
            window.localStorage.setItem(storageKey, JSON.stringify(newValue));
        }
        emitter.emit('change', {
            key: storageKey,
            value: newValue,
        });
    }, [storageKey]);
    return [value, set];
};
const parseSafely = (value) => {
    try {
        return JSON.parse(value);
    }
    catch (e) {
        return null;
    }
};
//# sourceMappingURL=use-persisted-state.js.map